/**
 * Apply a CSS Custom Property value or expression
 *
 * @param {Array} _ not required
 * @param {String} property expression for css property value
 * @returns {String} CSS custom property value applied string
 */
const apply = (_, property) => `var(--${property})`;

const theme = {
  color: {
    // hues
    "brand-green-hue": "127",
    "brand-purple-hue": "303",
    "brand-blue-hue": "191",
    "brand-pink-hue": "322",
    "brand-orange-hue": "25",
    "brand-red-hue": "355",
    "system-slate-hue": "219",
    "system-chrome-hue": "219",
    "system-mono-hue": "0",
    "system-danger-hue": "12",
    "system-warning-hue": "33",
    "system-success-hue": "159",
    "system-info-hue": "209",

    // brand green
    "color-brand-green-light-5": `hsla(124, 47%, 93%, 1)`,
    "color-brand-green-light-4": `hsla(125, 50%, 87%, 1)`,
    "color-brand-green-light-3": `hsla(126, 50%, 73%, 1)`,
    "color-brand-green-light-2": `hsla(126, 50%, 60%, 1)`,
    "color-brand-green-light-1": `hsla(${apply`hsla(${"brand-green-hue"})`}, 57%, 47%, 1)`,
    "color-brand-green-base": `hsla(${apply`hsla(${"brand-green-hue"})`}, 100%, 33%, 1)`,
    "color-brand-green-dark-1": `hsla(${apply`hsla(${"brand-green-hue"})`}, 100%, 27%, 1)`,
    "color-brand-green-dark-2": `hsla(126, 100%, 20%, 1)`,
    "color-brand-green-dark-3": `hsla(126, 100%, 13%, 1)`,
    "color-brand-green-dark-4": `hsla(125, 100%, 07%, 1)`,

    // brand purple
    "color-brand-purple-light-5": `hsla(306, 31%, 94%, 1)`,
    "color-brand-purple-light-4": `hsla(${apply`hsla(${"brand-purple-hue"})`}, 30%, 88%, 1)`,
    "color-brand-purple-light-3": `hsla(${apply`hsla(${"brand-purple-hue"})`}, 30%, 75%, 1)`,
    "color-brand-purple-light-2": `hsla(${apply`hsla(${"brand-purple-hue"})`}, 31%, 63%, 1)`,
    "color-brand-purple-light-1": `hsla(${apply`hsla(${"brand-purple-hue"})`}, 31%, 51%, 1)`,
    "color-brand-purple-base": `hsla(${apply`hsla(${"brand-purple-hue"})`}, 49%, 39%, 1)`,
    "color-brand-purple-dark-1": `hsla(${apply`hsla(${"brand-purple-hue"})`}, 49%, 31%, 1)`,
    "color-brand-purple-dark-2": `hsla(${apply`hsla(${"brand-purple-hue"})`}, 49%, 23%, 1)`,
    "color-brand-purple-dark-3": `hsla(${apply`hsla(${"brand-purple-hue"})`}, 49%, 15%, 1)`,
    "color-brand-purple-dark-4": `hsla(${apply`hsla(${"brand-purple-hue"})`}, 49%, 8%, 1)`,

    // brand blue
    "color-brand-blue-light-5": `hsla(189, 67%, 94%, 1)`,
    "color-brand-blue-light-4": `hsla(${apply`hsla(${"brand-blue-hue"})`}, 70%, 88%, 1)`,
    "color-brand-blue-light-3": `hsla(${apply`hsla(${"brand-blue-hue"})`}, 71%, 77%, 1)`,
    "color-brand-blue-light-2": `hsla(${apply`hsla(${"brand-blue-hue"})`}, 72%, 65%, 1)`,
    "color-brand-blue-light-1": `hsla(${apply`hsla(${"brand-blue-hue"})`}, 72%, 54%, 1)`,
    "color-brand-blue-base": `hsla(${apply`hsla(${"brand-blue-hue"})`}, 100%, 42%, 1)`,
    "color-brand-blue-dark-1": `hsla(${apply`hsla(${"brand-blue-hue"})`}, 100%, 34%, 1)`,
    "color-brand-blue-dark-2": `hsla(${apply`hsla(${"brand-blue-hue"})`}, 100%, 25%, 1)`,
    "color-brand-blue-dark-3": `hsla(${apply`hsla(${"brand-blue-hue"})`}, 100%, 17%, 1)`,
    "color-brand-blue-dark-4": `hsla(${apply`hsla(${"brand-blue-hue"})`}, 100%, 8%, 1)`,

    // brand pink
    "color-brand-pink-light-5": `hsla(322, 70%, 95%, 1)`,
    "color-brand-pink-light-4": `hsla(323, 74%, 90%, 1)`,
    "color-brand-pink-light-3": `hsla(323, 75%, 79%, 1)`,
    "color-brand-pink-light-2": `hsla(${apply`hsla(${"brand-pink-hue"})`}, 75%, 69%, 1)`,
    "color-brand-pink-light-1": `hsla(${apply`hsla(${"brand-pink-hue"})`}, 75%, 59%, 1)`,
    "color-brand-pink-base": `hsla(${apply`hsla(${"brand-pink-hue"})`}, 80%, 49%, 1)`,
    "color-brand-pink-dark-1": `hsla(${apply`hsla(${"brand-pink-hue"})`}, 80%, 39%, 1)`,
    "color-brand-pink-dark-2": `hsla(${apply`hsla(${"brand-pink-hue"})`}, 80%, 29%, 1)`,
    "color-brand-pink-dark-3": `hsla(${apply`hsla(${"brand-pink-hue"})`}, 80%, 19%, 1)`,
    "color-brand-pink-dark-4": `hsla(${apply`hsla(${"brand-pink-hue"})`}, 80%, 10%, 1)`,

    // brand orange
    "color-brand-orange-light-5": `hsla(23, 85%, 95%, 1)`,
    "color-brand-orange-light-4": `hsla(${apply`hsla(${"brand-orange-hue"})`}, 89%, 89%, 1)`,
    "color-brand-orange-light-3": `hsla(${apply`hsla(${"brand-orange-hue"})`}, 89%, 79%, 1)`,
    "color-brand-orange-light-2": `hsla(${apply`hsla(${"brand-orange-hue"})`}, 89%, 68%, 1)`,
    "color-brand-orange-light-1": `hsla(${apply`hsla(${"brand-orange-hue"})`}, 89%, 58%, 1)`,
    "color-brand-orange-base": `hsla(${apply`hsla(${"brand-orange-hue"})`}, 100%, 47%, 1)`,
    "color-brand-orange-dark-1": `hsla(${apply`hsla(${"brand-orange-hue"})`}, 100%, 38%, 1)`,
    "color-brand-orange-dark-2": `hsla(${apply`hsla(${"brand-orange-hue"})`}, 100%, 28%, 1)`,
    "color-brand-orange-dark-3": `hsla(${apply`hsla(${"brand-orange-hue"})`}, 100%, 19%, 1)`,
    "color-brand-orange-dark-4": `hsla(${apply`hsla(${"brand-orange-hue"})`}, 100%, 9%, 1)`,

    // brand red
    "color-brand-red-light-5": `hsla(354, 83%, 95%, 1)`,
    "color-brand-red-light-4": `hsla(354, 83%, 91%, 1)`,
    "color-brand-red-light-3": `hsla(${apply`hsla(${"brand-red-hue"})`}, 85%, 82%, 1)`,
    "color-brand-red-light-2": `hsla(${apply`hsla(${"brand-red-hue"})`}, 84%, 72%, 1)`,
    "color-brand-red-light-1": `hsla(${apply`hsla(${"brand-red-hue"})`}, 85%, 63%, 1)`,
    "color-brand-red-base": `hsla(${apply`hsla(${"brand-red-hue"})`}, 85%, 54%, 1)`,
    "color-brand-red-dark-1": `hsla(${apply`hsla(${"brand-red-hue"})`}, 72%, 43%, 1)`,
    "color-brand-red-dark-2": `hsla(${apply`hsla(${"brand-red-hue"})`}, 72%, 32%, 1)`,
    "color-brand-red-dark-3": `hsla(${apply`hsla(${"brand-red-hue"})`}, 73%, 22%, 1)`,
    "color-brand-red-dark-4": `hsla(${apply`hsla(${"brand-red-hue"})`}, 74%, 11%, 1)`,

    //slate
    "color-system-slate-light-5": `hsla(220, 17%, 93%, 1)`,
    "color-system-slate-light-4": `hsla(222, 18%, 86%, 1)`,
    "color-system-slate-light-3": `hsla(${apply`hsla(${"system-slate-hue"})`}, 18%, 72%, 1)`,
    "color-system-slate-light-2": `hsla(220, 18%, 58%, 1)`,
    "color-system-slate-light-1": `hsla(${apply`hsla(${"system-slate-hue"})`}, 23%, 44%, 1)`,
    "color-system-slate-base": `hsla(${apply`hsla(${"system-slate-hue"})`}, 42%, 31%, 1)`,
    "color-system-slate-dark-1": `hsla(${apply`hsla(${"system-slate-hue"})`}, 42%, 24%, 1)`,
    "color-system-slate-dark-2": `hsla(220, 42%, 18%, 1)`,
    "color-system-slate-dark-3": `hsla(${apply`hsla(${"system-slate-hue"})`}, 42%, 12%, 1)`,
    "color-system-slate-dark-4": `hsla(222, 42%, 6%, 1)`,

    //chrome
    "color-system-chrome-light-5": `hsla(216, 24%, 96%, 1)`,
    "color-system-chrome-light-4": `hsla(220, 22%, 92%, 1)`,
    "color-system-chrome-light-3": `hsla(220, 22%, 84%, 1)`,
    "color-system-chrome-light-2": `hsla(220, 22%, 76%, 1)`,
    "color-system-chrome-light-1": `hsla(220, 22%, 68%, 1)`,
    "color-system-chrome-base": `hsla(${apply`hsla(${"system-slate-hue"})`}, 23%, 60%, 1)`,
    "color-system-chrome-dark-1": `hsla(220, 15%, 48%, 1)`,
    "color-system-chrome-dark-2": `hsla(220, 15%, 36%, 1)`,
    "color-system-chrome-dark-3": `hsla(220, 15%, 24%, 1)`,
    "color-system-chrome-dark-4": `hsla(220, 15%, 12%, 1)`,

    //mono
    "color-system-mono-light-5": `hsla(${apply`hsla(${"system-mono-hue"})`}, 0%, 98%, 1)`,
    "color-system-mono-light-4": `hsla(${apply`hsla(${"system-mono-hue"})`}, 0%, 95%, 1)`,
    "color-system-mono-light-3": `hsla(${apply`hsla(${"system-mono-hue"})`}, 0%, 91%, 1)`,
    "color-system-mono-light-2": `hsla(${apply`hsla(${"system-mono-hue"})`}, 0%, 86%, 1)`,
    "color-system-mono-light-1": `hsla(${apply`hsla(${"system-mono-hue"})`}, 0%, 82%, 1)`,
    "color-system-mono-base": `hsla(${apply`hsla(${"system-mono-hue"})`}, 0%, 77%, 1)`,
    "color-system-mono-dark-1": `hsla(${apply`hsla(${"system-mono-hue"})`}, 0%, 62%, 1)`,
    "color-system-mono-dark-2": `hsla(${apply`hsla(${"system-mono-hue"})`}, 0%, 46%, 1)`,
    "color-system-mono-dark-3": `hsla(${apply`hsla(${"system-mono-hue"})`}, 0%, 31%, 1)`,
    "color-system-mono-dark-4": `hsla(${apply`hsla(${"system-mono-hue"})`}, 0%, 15%, 1)`,

    //danger
    "color-system-danger-light-5": `hsla(14, 72%, 94%, 1)`,
    "color-system-danger-light-4": `hsla(13, 75%, 89%, 1)`,
    "color-system-danger-light-3": `hsla(13, 75%, 78%, 1)`,
    "color-system-danger-light-2": `hsla(${apply`hsla(${"system-danger-hue"})`}, 76%, 67%, 1)`,
    "color-system-danger-light-1": `hsla(${apply`hsla(${"system-danger-hue"})`}, 76%, 56%, 1)`,
    "color-system-danger-base": `hsla(${apply`hsla(${"system-danger-hue"})`}, 92%, 45%, 1)`,
    "color-system-danger-dark-1": `hsla(${apply`hsla(${"system-danger-hue"})`}, 92%, 36%, 1)`,
    "color-system-danger-dark-2": `hsla(${apply`hsla(${"system-danger-hue"})`}, 93%, 27%, 1)`,
    "color-system-danger-dark-3": `hsla(13, 93%, 18%, 1)`,
    "color-system-danger-dark-4": `hsla(13, 96%, 9%, 1)`,

    //warning
    "color-system-warning-light-5": `hsla(${apply`hsla(${"system-warning-hue"})`}, 100%, 96%, 1)`,
    "color-system-warning-light-4": `hsla(32, 100%, 91%, 1)`,
    "color-system-warning-light-3": `hsla(${apply`hsla(${"system-warning-hue"})`}, 100%, 82%, 1)`,
    "color-system-warning-light-2": `hsla(32, 100%, 74%, 1)`,
    "color-system-warning-light-1": `hsla(${apply`hsla(${"system-warning-hue"})`}, 100%, 65%, 1)`,
    "color-system-warning-base": `hsla(${apply`hsla(${"system-warning-hue"})`}, 100%, 56%, 1)`,
    "color-system-warning-dark-1": `hsla(${apply`hsla(${"system-warning-hue"})`}, 79%, 45%, 1)`,
    "color-system-warning-dark-2": `hsla(32, 79%, 34%, 1)`,
    "color-system-warning-dark-3": `hsla(${apply`hsla(${"system-warning-hue"})`}, 79%, 22%, 1)`,
    "color-system-warning-dark-4": `hsla(32, 79%, 11%, 1)`,

    //success
    "color-system-success-light-5": `hsla(157, 35%, 93%, 1)`,
    "color-system-success-light-4": `hsla(158, 36%, 85%, 1)`,
    "color-system-success-light-3": `hsla(${apply`hsla(${"system-success-hue"})`}, 36%, 71%, 1)`,
    "color-system-success-light-2": `hsla(${apply`hsla(${"system-success-hue"})`}, 36%, 56%, 1)`,
    "color-system-success-light-1": `hsla(${apply`hsla(${"system-success-hue"})`}, 51%, 41%, 1)`,
    "color-system-success-base": `hsla(${apply`hsla(${"system-success-hue"})`}, 97%, 27%, 1)`,
    "color-system-success-dark-1": `hsla(${apply`hsla(${"system-success-hue"})`}, 98%, 21%, 1)`,
    "color-system-success-dark-2": `hsla(${apply`hsla(${"system-success-hue"})`}, 98%, 16%, 1)`,
    "color-system-success-dark-3": `hsla(${apply`hsla(${"system-success-hue"})`}, 100%, 11%, 1)`,
    "color-system-success-dark-4": `hsla(${apply`hsla(${"system-success-hue"})`}, 100%, 5%, 1)`,

    //info
    "color-system-info-light-5": `hsla(210, 67%, 94%, 1)`,
    "color-system-info-light-4": `hsla(${apply`hsla(${"system-info-hue"})`}, 70%, 88%, 1)`,
    "color-system-info-light-3": `hsla(${apply`hsla(${"system-info-hue"})`}, 71%, 77%, 1)`,
    "color-system-info-light-2": `hsla(${apply`hsla(${"system-info-hue"})`}, 72%, 65%, 1)`,
    "color-system-info-light-1": `hsla(${apply`hsla(${"system-info-hue"})`}, 72%, 54%, 1)`,
    "color-system-info-base": `hsla(${apply`hsla(${"system-info-hue"})`}, 100,% 42%, 1)`,
    "color-system-info-dark-1": `hsla(${apply`hsla(${"system-info-hue"})`}, 100%, 34%, 1)`,
    "color-system-info-dark-2": `hsla(${apply`hsla(${"system-info-hue"})`}, 100%, 25%, 1)`,
    "color-system-info-dark-3": `hsla(${apply`hsla(${"system-info-hue"})`}, 100%, 17%, 1)`,
    "color-system-info-dark-4": `hsla(${apply`hsla(${"system-info-hue"})`}, 100%, 8%, 1)`
  },
  style: {
    // border
    "border-width": "1px",

    // roundness
    "roundness-0": "0",
    "roundness-1": "2px",
    "roundness-2": "4px",
    "roundness-3": "8px",
    "roundness-4": "12px",
    "roundness-5": "16px",
    "roundness-99": "100%"
  },
  type: {
    // heading
    "heading-5xl": "2.32rem",
    "heading-4xl": "2rem",
    "heading-3xl": "1.75rem",
    "heading-2xl": "1.5rem",
    "heading-xl": "1.32rem",
    "heading-l": "1.13rem",
    "heading-m": "1rem",

    // line height
    "line-height": "1.4",

    //label
    "label-l": "1.13rem",
    "label-m": "1rem",
    "label-s": "0.88rem",
    "label-xs": "0.75rem",
    "label-2xs": "0.63rem",

    // body
    "body-l": "1.13rem",
    "body-m": "1rem",
    "body-s": "0.88rem",
    "body-xs": "0.75rem",

    // link
    "link-m": "1rem",
    "link-s": "0.88rem",

    //code
    "code-m": "1rem",
    "code-s": "0.88rem"
  },
  interactive: {
    // background
    "background-fill-primary": "hsla(0, 0%, 100%, 1)",
    "background-fill-secondary": "hsla(0, 0%, 98%, 1)",
    "background-fill-highlight": "hsla(220, 22%, 92%, 1)",
    "background-fill-brand": "hsla(127, 100%, 33%, 1)",
    "background-fill-inverse": "hsla(219, 42%, 24%, 1)",
    "background-border-solid-primary": "solid hsla(0, 0%, 86%, 1)",
    "background-border-solid-secondary": "solid hsla(0, 0%, 91%, 1)",
    "background-border-dotted-primary": "dotted hsla(0, 0%, 86%, 1)",
    "background-border-dotted-secondary": "dotted hsla(0, 0%, 91%, 1)",

    // text
    "text-primary": "hsla(220, 42%, 18%, 1)",
    "text-secondary": "hsla(219, 42%, 24%, 1)",
    "text-muted": "hsla(219, 23%, 60%, 1)",
    "text-inverse": "hsla(0, 0%, 100%, 1)",
    "text-brand": "hsla(127, 100%, 33%, 1)",
    "text-disabled": "hsla(0, 0%, 62%, 1)",

    // font-family
    "font-display": `"Maison Neue Extended"`,

    //icon
    "icon-primary": "hsla(220, 42%, 24%, 1)",
    "icon-muted": "hsla(219, 23%, 60%, 1)",
    "icon-inverse": "hsla(0, 0%, 100%, 1)",
    "icon-brand": "hsla(127, 100%, 33%, 1)",
    "icon-disabled": "hsla(0, 0%, 62%, 1)",

    //link
    "link-default": "hsla(209, 100%, 25%, 1)",
    "link-hover": "hsla(209, 100%, 42%, 1)",
    "link-active": "hsla(209, 100%, 25%, 1)",
    "link-visited": "hsla(309, 49%, 23%, 1)",

    //interactive
    "interactive-fill-brand-default": "hsla(127, 100%, 33%, 1)",
    "interactive-fill-brand-hover": "hsla(127, 57%, 47%, 1)",
    "interactive-fill-brand-active": "hsla(127, 100%, 27%, 1)",

    "interactive-fill-default": "hsla(0, 0%, 100%, 1)",
    "interactive-fill-hover": "hsla(216, 24%, 96%, 1)",
    "interactive-fill-active": "hsla(220, 17%, 93%, 1)",
    "interactive-fill-alternate": "transparent",

    "interactive-fill-selected-default": "hsla(219, 42%, 31%, 1)",
    "interactive-fill-selected-hover": "hsla(219, 23%, 44%, 1)",
    "interactive-fill-selected-active": "hsla(219, 42%, 24%, 1)",

    "interactive-disabled": "hsla(0, 0%, 86%, 1)",
    "interactive-focus": "hsla(219, 42%, 18%, 1)",

    //input
    "interactive-border-solid": "solid hsla(220, 22%, 76%, 1)",
    "interactive-border-dotted": "dotted hsla(220, 22%, 76%, 1)",
    "interactive-border-support": "hsla(12, 92%, 36%, 1)",

    //support
    "support-danger-default": "hsla(12, 92%, 45%, 1)",
    "support-danger-hover": "hsla(12, 76%, 56%, 1)",
    "support-danger-active": "hsla(12, 92%, 36%, 1)",
    "support-danger-fill": "hsla(14, 72%, 94%, 1)",

    "support-warning-default": "hsla(33, 100%, 56%, 1)",
    "support-warning-hover": "hsla(33, 100%, 65%, 1)",
    "support-warning-active": "hsla(33, 79%, 45%, 1)",
    "support-warning-fill": "hsla(33, 100%, 96%, 1)",

    "support-success-default": "hsla(159, 97%, 27%, 1)",
    "support-success-hover": "hsla(159, 51%, 41%, 1)",
    "support-success-active": "hsla(159, 98%, 21%, 1)",
    "support-success-fill": "hsla(157, 35%, 93%, 1)",

    "support-info-default": "hsla(209, 100%, 42%, 1)",
    "support-info-hover": "hsla(209, 72%, 54%, 1)",
    "support-info-active": "hsla(209, 100%, 34%, 1)",
    "support-info-fill": "hsla(210, 67%, 94%, 1)",

    "support-neutral-fill": "hsla(220, 17%, 93%, 1)",

    //overlay
    "overlay-white": "hsla(0, 0%, 100%, 0.8)",
    "overlay-black": "hsla(219, 42%, 18%, 0.8)",

    //shadow
    "shadow-low": "0px 0px 10px 0px hsla(222, 42%, 6%, 0.1)",
    "shadow-high": "0px 0px 14px 0px hsla(222, 42%, 6%, 0.14)"
  }
};

const toCSS = theme => {
  Object.keys(theme).forEach(catkey => {
    const category = Object.create(null);
    Object.keys(theme[catkey]).forEach(key => {
      category[`--${key}`] = theme[catkey][key];
    });

    theme[catkey] = { ...category };
  });

  return theme
};

const merge = theme =>
  Object.keys(theme).reduce(
    (acc, curr) => ({ ...acc, ...theme[curr] }),
    Object.create(null)
  );

const variables = merge(toCSS(theme));
module.exports = variables;
